// Dependencies
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";

// Images
import BannerSignUp from "../images2/Banner_signup.png";

import ReCAPTCHA from "react-google-recaptcha";
// Styles
import "../styles/Signup.scss";
import Swal from "sweetalert2";
import { signUpClient, successfullSignUp } from "../services/LoginService";
import useForm from "../hooks/useForm";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { ModalTerminos } from "../components/ModalTerminos";
import { FaHome } from "react-icons/fa";

export const Signup = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [buttonInner, setButtonInner] = useState("Registrarse");
  const [buttonDisable, setButtonDisable] = useState(false);
  let dataArray;
  let initialState = {
    fullName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    email: {
      test: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message:
        "El correo solo puede contener letras, numeros, puntos y guiones.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit } = useForm(
    initialState,
    validations
  );

  const submitForm = async (event) => {
    event.preventDefault();
    if (!captchaToken) {
      alert("Please verify the captcha");
      return;
    }
    setButtonDisable(true)
    setButtonInner(<img height={20} src="loading-button.gif"></img>)
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setButtonInner("Registrarse")
      setButtonDisable(false)
      event.stopPropagation();
    } else {
      dataArray = {
        nombre: formData.fullName,
        apellido: formData.lastName,
        email: formData.email,
        telefono: formData.phone,
        contrasena: formData.password,
      };
      const dataEmail = {
        destinatario: formData.email,
        asunto: "Bienvenido a Marzah Travel.",
        mensaje: "Registro Exitoso",
        userName: `${formData.fullName} ${formData.lastName}`,
      };
      try {
        await signUpClient(dataArray);
        await successfullSignUp(dataEmail);
        await Swal.fire({
          title: "Se ha registrado exitosamente!",
          text: "Desea iniciar sesión?",
          icon: "success",
          confirmButtonText: "Iniciar Sesión",
          denyButtonText: "Ir al Inicio",
          showDenyButton: true,
          confirmButtonColor: "#0044aa",
          denyButtonColor: "#6f6767",
        }).then((e) => {
          if (e.isConfirmed) {
            navigate("/login");
          } else if (e.isDenied) {
            navigate("/");
          }
          navigate("/login");
        });
      } catch (error) {
        setButtonInner("Registrarse")
        setButtonDisable(false)
        console.error("Hubo un error al registrarse:", error);
        Swal.fire({
          icon: "error",
          title: "Hubo un error al registrarse.",
          text: "El correo ingresado ya existe por favor intente con otro.",
        });
      }
      setButtonInner("Registrarse")
      setButtonDisable(false)
    }
    setValidated(true);
  };

  const handleShowModal = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  return (
    <div>
      <img
        src={BannerSignUp}
        alt="Banner Sign Up"
        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
      />
      <Form
        className="signup-form needs-validation rounded-4 shadow"
        onSubmit={submitForm}
        // onSubmit={(e) => handleSubmit(e, submitForm)}
        noValidate
        validated={validated}
      >
        <Row className="m-0">
          <Col xs={12}>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Ir al Inicio</Tooltip>}
            >
              <Button onClick={() => navigate("/")} variant="secondary">
                <FaHome />
              </Button>
            </OverlayTrigger>
          </Col>
          <Col xs={12} className="text-center">
            <img
              src={
                "https://panel.marzahtravel.com/assets/img/logoHeaderBlanco.png"
              }
              className="w-auto"
              alt=""
            />
          </Col>
          <Col lg={6} md={6} xs={12} className="my-2">
            <Form.Group controlId="formEmail">
              <Form.Label className="text-white">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                isInvalid={
                  validated &&
                  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                }
              />
              <Form.Control.Feedback type="invalid">
                Email inválido.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} xs={12} className="my-2">
            <Form.Group controlId="formPhone">
              <Form.Label className="text-white">Telefono</Form.Label>
              <Form.Control
                type="text"
                minLength={10}
                name="phone"
                placeholder="Telefono"
                value={formData.phone}
                onChange={handleChange}
                required
                isInvalid={validated && !/^\d*$/.test(formData.phone)}
              />
              <Form.Control.Feedback type="invalid">
                El teléfono debe tener como mínimo 10 dígitos.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} xs={12}>
            <Form.Group controlId="formFullName">
              <Form.Label className="text-white">Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nombre"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                isInvalid={
                  validated && !/^[a-zA-Z\s]*$/.test(formData.fullName)
                }
              />
              <Form.Control.Feedback type="invalid">
                Ingrese su nombre.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} xs={12}>
            <Form.Group controlId="formLastName">
              <Form.Label className="text-white">Apellido</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                placeholder="Apellido"
                value={formData.lastName}
                onChange={handleChange}
                required
                isInvalid={
                  validated && !/^[a-zA-Z\s]*$/.test(formData.lastName)
                }
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su apellido.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col lg={6} md={6} xs={12}>
            <Form.Group controlId="formPassword">
              <Form.Label className="text-white">Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                isInvalid={validated && formData.password.length < 6}
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese una contraseña válida.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6} md={6} xs={12}>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label className="text-white">Confirm Password</Form.Label>
              <Form.Control
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                isInvalid={
                  validated && formData.confirmPassword !== formData.password
                }
              />
              <Form.Control.Feedback type="invalid">
                La contraseña no coincide.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={12} md={12} sm={12} className="">
            <div className="d-flex justify-content-between my-3">
              <Form.Group>
                <Form.Check.Input
                  required
                  type="checkbox"
                  name="termsAccepted"
                  // checked={formData.termsAccepted}
                  onChange={handleChange}
                  isInvalid={validated && !formData.termsAccepted}
                />
                <Form.Check.Label
                  className="ms-2 text-white"
                  onClick={handleShowModal}
                  style={{ cursor: "pointer" }}
                >
                  He leído y acepto los términos y condiciones.
                </Form.Check.Label>
                 <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    onChange={setCaptchaToken}
                    className="w-100"
                  />
                <Form.Control.Feedback type="invalid">
                  Debe aceptar los términos y condiciones.
                </Form.Control.Feedback>
                <ModalTerminos
                  openModal={showModal}
                  setOpenModal={setShowModal}
                />
              </Form.Group>
              <p className="text-white">
                Ya tengo una cuenta.{" "}
                <Link className="text-white" to="/login">
                  Iniciar sesión
                </Link>
              </p>
            </div>
            <Form.Group controlId="formSubmit" className="text-end">
              <Form.Label></Form.Label>
              <Button className="btn-register" disabled={buttonDisable} type="submit">
                {buttonInner}
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
